<template>
  <f7-app v-bind="f7params">
    <f7-view :main="true" url="/" class="safe-areas" :master-detail-breakpoint="768" :master-detail-resizable="true"
      :browser-history="browserHistoryEnabled" :browser-history-root="browserHistoryRoot"
      :browser-history-separator="''" :browser-history-initial-match="true" @view:resize="viewResize()">
      <!-- :icons="isLargeScreen || device.md" -->
      <f7-toolbar v-show="showMainToolbar" tabbar icons no-shadow :position="isLargeScreen ? 'top' : 'bottom'"
        class="mainToolbar webToolbar mainAppToolbar">
        <f7-toolbar-pane>
          <f7-link v-if="isLargeScreen" href="/" id="avocashLogo" class="avocashLogoLink" style="
              min-width: 140px;
              display: flex;
              align-items: center;
              flex-direction: row;
              gap: 8px;
            ">
            <img src="/512x512.svg" :alt="$t('common.a11y.appLogo')" class="avocash_logo" width="28" height="28"
              style="vertical-align: middle" />
            <avo_name></avo_name>
          </f7-link>
          <f7-searchbar v-if="isLargeScreen" class="feedSearchbar" inline custom-search :backdrop="false"
            :placeholder="$t('common.search')" :disable-button="false" :clear-button="true"
            :value="feedStore.searchQuery" @input="onSearchInput" @searchbar:clear="onSearchClear"></f7-searchbar>
          <span class="linkedinNav">
            <f7-link tab-link href="/" route-tab-id="view-home" icon-ios="f7:house_fill" icon-md="material:home"
              transition="f7-parallax" :text="$t('home.home')" :tab-link-active="activeTab === 'view-home'"></f7-link>
            <!-- <f7-link
            tab-link
            icon-ios="f7:doc_richtext"
            icon-md="material:feed"            route-tab-id="view-fairia"
            href="/fairia/"
            transition="f7-fade"
            :tab-link-active="activeTab === 'view-fairia'"
          ></f7-link> -->
            <f7-link tab-link icon-ios="material:store" icon-md="material:store" route-tab-id="view-stores"
              :text="$t('home.stores')" href="/stores/" transition="f7-parallax"
              :tab-link-active="activeTab === 'view-stores'"></f7-link>
            <f7-link tab-link href="/dashboard/" transition="f7-parallax" route-tab-id="view-dashboard" v-if="authenticated"
              icon-ios="f7:person_crop_circle_fill" icon-md="material:account_circle" :text="$t('common.account')"
              :tab-link-active="activeTab === 'view-dashboard'">
            </f7-link>
            <f7-link tab-link href="/groups/" route-tab-id="view-groups" icon-ios="f7:circle_grid_hex_fill"
              icon-md="material:group_work" :text="$t('home.groups')" transition="f7-parallax" v-if="authenticated"
              :tab-link-active="activeTab === 'view-groups'"></f7-link>
            <f7-link href="/message/" route-tab-id="view-tamtam" tab-link :text="$t('home.tamtam')"
              icon-ios="f7:bubble_left_bubble_right_fill" icon-md="material:chat" transition="f7-parallax" v-if="authenticated"
              :tab-link-active="activeTab === 'view-tamtam'">
            </f7-link>
            <f7-link tab-link href="/cart/" route-tab-id="view-cart" transition="f7-parallax"
              v-if="cart && cart.length > 0 && isLargeScreen" class="toolbarDeskTop"
              :tab-link-active="activeTab === 'view-cart'">
              <f7-icon ios="f7:cart" aurora="f7:cart" md="material:shopping_cart" color="none">
                <f7-badge bg-color="none" class="text-align-center" :style="{
                  ' font-size': '50%',
                  'margin-left': totalItemCount > 9 ? '-23px' : '-20px',
                  top: '-5px',
                  'font-weight': bold,
                }" text-color="red" v-if="cart && cart.length >= 1">{{ totalItemCount }}</f7-badge>
              </f7-icon>
              <span class="tabbar-label">{{ $t("home.cart") }}</span>
            </f7-link>
            
          </span>
          <span class="linkedinActions" style="display: flex; align-items: center; gap: 12px;">
            <!-- <f7-link tab-link target="_blank" data-route-tab-id="#" v-if="isLargeScreen" class="qrCodeScannerIcon display-flex"> -->
              <navbarleft v-if="isLargeScreen"></navbarleft>
              <!-- <span>&nbsp;</span> -->
            <!-- </f7-link> -->
            <!-- <span class="margin-right" tab-link data-route-tab-id="#" target="_blank"
              style="display: flex; align-items: center; flex-direction: column" v-if="authenticated && isLargeScreen"> -->
              <navbarright v-if="authenticated && isLargeScreen"></navbarright>
              <!-- <span>&nbsp;</span> -->
            <!-- </span> -->
            <span class="tab-link" data-route-tab-id="#" style="display: flex; align-items: center; justify-content: center"
              v-if="!authenticated && isLargeScreen">
              <f7-button small round-md outline round raised class="registerButton signUpSignIn" color="auto"
                @click="registerFn()">{{ $t("common.register") }}</f7-button>
            </span>
            <span class="tab-link" data-route-tab-id="#" style="display: flex; align-items: center; justify-content: center"
              v-if="!authenticated && isLargeScreen">
              <f7-button small outline round round-md raised class="loginButton signUpSignIn"
                @click="loginFn()">{{ $t("common.login") }}</f7-button></span>
          </span>
        </f7-toolbar-pane>
      </f7-toolbar>
    </f7-view>
    <html5QRScan></html5QRScan>
    <navbarleft></navbarleft>
    <editDocs></editDocs>
    <attachDoc></attachDoc>
    <navbarright></navbarright>
    <panelright></panelright>
    <pwaInstall></pwaInstall>
    <createGroupPanel></createGroupPanel>
    <transactAuthPanel></transactAuthPanel>
    <authMethodPicker></authMethodPicker>
    <countryPicker></countryPicker>
  </f7-app>
</template>
<style lang="css">
.avocash_gold {
  color: #c9a84c;
}
</style>
<style scoped>
@media screen and (min-width: 768px) {
  .homePage {
    width: 60% !important;
    margin-left: 20% !important;
    min-width: 768px;
  }
}

.signUpSignIn {
  border-radius: 32px;
  border-width: medium;
  /* match the bar behind the button so the outline + label carry visibility
     in both themes (page-bg went dark-on-dark on the dark toolbar) */
  background: var(--f7-bars-bg-color, #fff);
}

.registerButton {
  border-color: var(--f7-theme-color);
}

.loginButton {
  border-color: var(--f7-on-surface, #1c1c1e);
  color: var(--f7-on-surface, #1c1c1e);
}
</style>

<script setup>
import { ref, computed, watch, onMounted, getCurrentInstance } from "vue";
import { f7, f7ready, theme } from "framework7-vue";
import { getDevice } from "framework7/lite-bundle";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { ScreenOrientation } from "@capacitor/screen-orientation";
import { Browser } from "@capacitor/browser";
import _ from "lodash";

import routes, { guardInitialRoute } from "../js/routes.js";
import capacitorApp from "../js/capacitor-app.js";
import { hideBrowserSplash } from "../js/browser-splash.js";

import i18n from "../js/i18n.js";

import { useCordovaPlugin } from "../js/composables/useCordovaPlugin.js";
import { useSocialShare } from "../js/composables/useSocialShare.js";
import { useHandleLink } from "../js/composables/useHandleLink.js";
import { useWebSocket } from "../js/composables/useWebSocket.js";
import { useFirebase } from "../js/composables/useFirebase.js";
import { usePwa } from "../js/composables/usePwa.js";
import { useIdleSession } from "../js/composables/useIdleSession.js";

import { useLogin } from "../js/composables/useLogin.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useLargeScreen, useTabletScreen } from "../js/composables/useMediaQuery.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { useLocationStore } from "../js/pinia-stores/location.js";
import { useShoppingCartStore } from "../js/pinia-stores/shoppingCart.js";
import { useMessageStore } from "../js/pinia-stores/message.js";
import { useApimoneyStore } from "../js/pinia-stores/apimoney.js";
import { useFeedStore } from "../js/pinia-stores/feed.js";

import avo_name from "./avocash_name.vue";
import navbarright from "./navbarright.vue";
import html5QRScan from "./html5QRScan.vue";
import editDocs from "./editDocs.vue";
import attachDoc from "./attachDocs.vue";
import pwaInstall from "./pwa-install.vue";
import navbarleft from "./navbarleft.vue";
import panelright from "../pages/panel-right.vue";
import createGroupPanel from "./tamtam/createGpPanel.vue";
import transactAuthPanel from "./TransactAuthPanel.vue";
import authMethodPicker from "./AuthMethodPicker.vue";
import countryPicker from "./CountryPicker.vue";

useCordovaPlugin();
// if (Capacitor.isNativePlatform()) {
  useHandleLink();
// }
useSocialShare();
useFirebase();
usePwa();
useIdleSession();

const { connectMessageSocket: wsConnectMessageSocket } = useWebSocket();

const proxy = getCurrentInstance().proxy;
const { loginFn, registerFn, logoutFn } = useLogin();

const authStore = useAuthStore();
const keycloakStore = useKeycloakStore();
const accountStore = useAccountStore();
const locationStore = useLocationStore();
const shoppingCartStore = useShoppingCartStore();
const messageStore = useMessageStore();
const apimoneyStore = useApimoneyStore();
const feedStore = useFeedStore();

const t = i18n.global.t;
const device = getDevice();
const browserHistoryEnabled = !Capacitor.isNativePlatform();
const browserHistoryRoot = `${window.location.origin}`;
const isLargeScreen = useLargeScreen().matches;
const isTablet = useTabletScreen().matches;
let countryData = [];

async function ensureCountryData() {
  if (countryData.length > 0) return countryData;

  try {
    const countryDataModule = await import("intl-tel-input/data");
    countryData = countryDataModule.default;
    return countryData;
  } catch (error) {
    console.warn("Could not load intl-tel-input country data:", error);
    return [];
  }
}

const currDevice = ref("");
const isReady = ref(false);
const activeTab = ref("view-home");

// ── Main toolbar visibility ──────────────────────────────────────────────
// The main tab bar is visible ONLY on the main tab pages listed below.
// Paths are normalized (query string + trailing slashes removed) before
// matching, so "/dashboard", "/dashboard/" and "/dashboard?x=1" all resolve.
const TOOLBAR_VISIBLE_ROUTES = ["/", "/stores", "/dashboard", "/groups", "/message", "/cart"];
const showMainToolbar = ref(true);

function normalizePath(path) {
  if (!path) return "/";
  const clean = String(path).split("?")[0].replace(/\/+$/, "");
  return clean === "" ? "/" : clean;
}

function isToolbarVisible(path) {
  return TOOLBAR_VISIBLE_ROUTES.includes(normalizePath(path));
}

// Single entry point keeping active tab + toolbar visibility in sync with
// the current route. Call this on routeChange and on initial load.
function syncToolbar(route) {
  const path = normalizePath(route?.path || "");
  activeTab.value = tabIdForPath(path);
  showMainToolbar.value = isToolbarVisible(path);
}

const f7params = {
  id: "com.avocash.pay",
  name: "avo¢ash",
  theme: "auto",
  version: "1.1.0",
  language: navigator.language.split("-")[0],
  colors: {
    primary: "#1a6b42",
  },
  routes,
  serviceWorker: !Capacitor.isNativePlatform()
    ? process.env.NODE_ENV === "production"
      ? { path: "/service-worker.js" }
      : { path: "" }
    : "",
  view: {
    browserHistoryTabs:
      Capacitor.getPlatform() === "web" &&
        !device.standalone &&
        !device.webview &&
        !device.webView
        ? "push"
        : "replace",
    masterDetailResizable: true,
    masterDetailBreakpoint: 768,
    mdSwipeBack: true,
    iosSwipeBack: true,
    reloadDetail: false,
    transition: "f7-parallax",
  },
  input: {
    scrollIntoViewOnFocus: device.capacitor,
    scrollIntoViewCentered: device.capacitor,
  },
  statusbar: {
    iosOverlaysWebView: true,
    androidOverlaysWebView: true,
    androidBackgroundColor: "#FFFFFFFF",
    androidTextColor: "black",
    iosBackgroundColor: "#FFFFFFFF",
    iosTextColor: "black",
  },
  navbar: {
    hideOnPageScroll: !device.ios,
    iosCenterTitle: true,
    mdCenterTitle: false,
    backLinkShowText: false,
    sliding: true,
    transparent: true,
    outline: false,
  },
  toolbar: { hideOnPageScroll: !device.ios },
  tabbar: { hideOnPageScroll: !device.ios },
  actions: {
    convertToPopover: true,
    closeOnEscape: true,
    closeByOutsideClick: true,
    swipeToClose: true,
  },
  popup: {
    closeOnEscape: true,
    tabletFullscreen: false,
    popupCloseLinkText: '<i class="icon f7-icons">multiply</i>',
    animate: true,
    swipeToClose: true,
    closeByOutsideClick: true,
  },
  sheet: {
    closeOnEscape: true,
    swipeToClose: true,
    closeByOutsideClick: true,
    animate: true,
  },
  popover: {
    closeOnEscape: true,
    backdrop: false,
    closeByOutsideClick: true,
    swipeToClose: true,
  },
  calendar: {
    toolbarCloseText:"",// t("common.done"),
    headerPlaceholder: t("common.selectDate"),
    openIn: "auto",
    swipeToClose: true,
  },
  dialog: {
    title: `<div class='box' style='align-items:justify;'><img src='/512x512.svg'  class="avocash_logo" alt='avocash icon' width='32' height='32' style='margin-right:8px; vertical-align: middle;' class='elevation-3'/><span class="avocash"><span class="avocash_primary">avo</span><span class="avocash_gold avocash">¢</span><span class="avocash_primary">ash</span></span></div>`,
    buttonOk: t("common.buttonOk"),
    buttonCancel: t("common.cancel"),
  },
  notification: {
    icon:
      '<i class="icon elevation-3"><img src="/512x512.svg"  class="avocash_logo" width="32" height="32" alt="avocash icon"></i>',
    title: `<span class="avocash"><span class="avocash_primary">avo</span><span class="avocash_gold avocash">¢</span><span class="avocash_primary">ash</span></span>`,
  },
  touch: {
    tapHold: true,
    tapHoldDelay: 750,
    touchClicksDistanceThreshold: 5,
    activeState: true,
  },
  clicks: { externalLinks: ".external" },
  photoBrowser: {
    pageBackLinkText: "",
    navbarOfText: "/",
    type: "standalone",
    swipeToClose: true,
  },
  smartSelect: {
    searchbarDisableText: t("common.cancel"),
    pageBackLinkText: "",
    swipeToClose: true,
    popupTabletFullscreen: false,
    sheetCloseLinkText:"",// t("common.done"),
    searchbarPlaceholder: t("common.search"),
    openIn: isLargeScreen ? "popup" : "sheet",
  },
  searchbar: {
    disableButtonText: t("common.cancel"),
    placeholder: t("common.search"),
  },
  textEditor: {
    mode: "keyboard-toolbar",
    imageUrlText: t("common.imageUrlText"),
    linkUrlText: t("common.linkUrlText"),
  },
  swiper: { keyboard: { enabled: true }, mousewheel: true },
};

const isUserAuthenticated = computed(() => keycloakStore.authenticated);
const authenticated = computed(() => keycloakStore.authenticated);
const subject = computed(() => keycloakStore.subject);

const destinationCity = computed(() => locationStore.destinationCity);
const country = computed(() => locationStore.country);
const currencyList = computed(() => locationStore.currencyList);
const currentUserCountry = computed(() => locationStore.currentUserCountry);
const userAddress = computed(() => locationStore.userAddress);
const emoneyApiList = computed(() => locationStore.emoneyApiList);

const destinationCountry = computed(() => transactionStore.destinationCountry);
const originCountry = computed(() => transactionStore.originCountry);
const ipAddress = computed(() => transactionStore.ipAddress);

const profile = computed(() => authStore.profile);
const token = computed(() => authStore.token);
const user = computed(() => authStore.user);
const keycloak = computed(() => authStore.keycloak);
const topath = computed(() => authStore.topath);
const phoneNumberDetail = computed(() => authStore.phoneNumberDetail);
const mobilePhoneError = computed(() => authStore.mobilePhoneError);
const isNativePlatform = computed(() => authStore.isNativePlatform);
const locale = computed(() => authStore.locale);
const lastSwiperIsActive = computed(() => authStore.lastSwiperIsActive);
const csrfToken = computed(() => authStore.csrfToken);

const cart = computed(() => shoppingCartStore.cart);
const cartItemCount = computed(() => shoppingCartStore.cartItemCount);
const totalCartAmount = computed(() => shoppingCartStore.totalCartAmount);
const totalItemCount = computed(() => shoppingCartStore.totalItemCount);

const userAccount = computed(() => accountStore.userAccount);
const standard = computed(() => accountStore.standard);
const business = computed(() => accountStore.business);
const accountList = computed(() => accountStore.accountList);
const userGroupList = computed(() => accountStore.userGroupList);

const allowedCountries = computed(() => apimoneyStore.allowedCountries);

const groupList = computed(() => messageStore.groupList);
const chatUser = computed(() => messageStore.chatUser);
const messageSocketClient = computed(() => messageStore.messageSocketClient);
const msgCltConnected = computed(() => messageStore.msgCltConnected);

function findCountryInCountrydata(countryCode) {
  if (!countryCode || countryCode === "") {
    return null;
  }
  countryCode = countryCode.toLowerCase();
  for (const countryDaton of countryData) {
    if (countryDaton.iso2 === countryCode) {
      return countryDaton;
    }
  }
  return null;
}

function onSearchInput(event) {
  feedStore.setSearchQuery(event.target.value);
}

function onSearchClear() {
  feedStore.clearSearch();
}

function setActiveTab(tab) {
  activeTab.value = tab;
}

function tabIdForPath(path) {
  const p = normalizePath(path);
  if (p === "/") return "view-home";
  if (p.startsWith("/message")) return "view-tamtam";
  if (p.startsWith("/cart")) return "view-cart";
  if (p.startsWith("/dashboard")) return "view-dashboard";
  if (p.startsWith("/groups")) return "view-groups";
  if (p.startsWith("/stores")) return "view-stores";
  return "view-home";
}

function viewResize() {
  if (f7.views.main.resizable && f7.views.main.resizableInitialized) {
    console.log("viewResize", f7.views.main);
    authStore.setMasterWidth(f7.views.main.resizableWidth);
  }
}

// QA probe for A9: report env() safe-area insets in standalone PWA where the
// status-bar-style meta is "default" (no overlay) — zero top inset is expected
// there; warn only when an overlay context reports zeros (would mean env() is
// unsupported and --f7-safe-area-* collapse to 0px).
function probeSafeAreaInsets() {
  if (!import.meta.env.DEV) return;
  const probe = document.createElement("div");
  probe.style.cssText =
    "position:absolute;top:-9999px;pointer-events:none;" +
    "padding-top:env(safe-area-inset-top);" +
    "padding-bottom:env(safe-area-inset-bottom);";
  document.body.appendChild(probe);
  const cs = getComputedStyle(probe);
  const top = parseFloat(cs.paddingTop) || 0;
  const bottom = parseFloat(cs.paddingBottom) || 0;
  probe.remove();
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
  const overlayExpected = Capacitor.isNativePlatform() && !device.ios;
  if (standalone && overlayExpected && top === 0 && bottom === 0) {
    console.warn(
      "[safe-area] env() insets are 0 in overlay context — verify --f7-safe-area-* fallbacks"
    );
  } else {
    console.info(
      `[safe-area] env() probe: top=${top}px bottom=${bottom}px standalone=${standalone}`
    );
  }
}

onMounted(() => {
  currDevice.value = device;
  isReady.value = true;
  ensureCountryData();
  probeSafeAreaInsets();

  f7ready(() => {
    if (device.capacitor) {
      capacitorApp.init(f7);
    }
    hideBrowserSplash();

    f7.on("page:beforeout", () => {
      if (authStore.documentsUrl.length > 0) {
        authStore.clearDocumentsUrl();
      }
    });
    f7.on("popup:closed", () => {
      if (authStore.documentsUrl.length > 0) {
        authStore.clearDocumentsUrl();
      }
    });
    f7.on("sheet:closed", () => {
      if (authStore.documentsUrl.length > 0) {
        authStore.clearDocumentsUrl();
      }
    });

    // Main toolbar visibility: shown only on TOOLBAR_VISIBLE_ROUTES.
    const mainRouter = f7.views.main && f7.views.main.router;
    if (mainRouter) {
      mainRouter.on("routeChange", syncToolbar);
      // Evaluate the initial route (deep links / refresh on an inner page).
      syncToolbar(mainRouter.currentRoute);
      // Framework7-Vue pre-renders the initial matched route without running
      // beforeEnter guards, so guarded deep links must be checked here.
      guardInitialRoute(mainRouter.currentRoute, mainRouter);
    }
  });

  requestAnimationFrame(() => {
    if (!allowedCountries.value || allowedCountries.value.length === 0) {
      apimoneyStore.getAllowedCountries();
    }
  });

  if (device.ios) {
    document.querySelectorAll(".item-input").forEach((input) => {
      input.classList.remove("item-input-outline");
    });
  }
  document.querySelectorAll("[href]").forEach((element) => {
    const href = element.getAttribute("href");
    if (
      href &&
      href !== "#" &&
      href.trim() !== "" &&
      !href.includes("avocash.com") &&
      !href.startsWith("/")
    ) {
      element.classList.add("external");
    }
  });
  document.querySelectorAll(".external").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const href = e.currentTarget.getAttribute("href");
      if (href && href !== "#" && href.trim() !== "") {
        try {
          const currUrl = new URL(href, window.location.origin);
          console.log("currUrl", currUrl);
          Browser.open({ url: currUrl.href });
        } catch (error) {
          console.error("Invalid URL:", href, error);
        }
      }
    });
  });

  if (Capacitor.isNativePlatform() && !isTablet.value) {
    ScreenOrientation.lock({ orientation: "portrait" });
  }

  console.log("device", device);
  console.log("f7 theme", theme);
  console.log("f7", f7);
  console.log("window.location", window.location);
  authStore.isNativePlatform_set(Capacitor.isNativePlatform());

  viewResize();
  const root = document.documentElement;
  root.style.setProperty("--f7-panel-shadow", "transparent");
  console.log("root", root);
  requestAnimationFrame(() => {
    if (!msgCltConnected.value) {
      if (csrfToken.value === "") {
        authStore.getCsrfToken();
      }
      setTimeout(() => {
        wsConnectMessageSocket();
      }, 6000);
    }

    if (
      (f7.utils.now() - window.localStorage.getItem("cartDuration")) / 60000 > 30 &&
      !authenticated.value
    ) {
      shoppingCartStore.deleteCart();
    }

    locationStore.getCurrentUserIpAddress();
  });

  if (!currencyList.value) {
    locationStore.getCurrencyList();
  }
  if (!emoneyApiList.value) {
    locationStore.getEmoneyApiList();
  }
  if (!country.value) {
    locationStore.getCountry();
  }
  if (
    Array.isArray(country.value) &&
    country.value.length > 0 &&
    !country.value[0].name
  ) {
    const countries = country.value.map((c) => {
      if (!c) return c;
      const cData = findCountryInCountrydata(c.countryCode2);
      return cData
        ? {
          ...c,
          name: cData.name,
          iso2: cData.iso2,
          dialCode: cData.dialCode,
        }
        : {
          ...c,
          name: c.countryName,
          iso2: c.countryCode2 ? c.countryCode2.toLowerCase() : "",
          dialCode: c.phoneCode ? `+${c.phoneCode}` : "",
        };
    });
    locationStore.setCountries(countries);
  }

  const storedKeys = window.__piniaLcStorage.getAllKeys();
  if (storedKeys && storedKeys.length > 0) {
    storedKeys.forEach((key) => {
      let item;
      try {
        item = window.__piniaLcStorage.get(key);
      } catch (err) {
        console.error(`avocash: purging unreadable storage key "${key}"`, err);
        window.__piniaLcStorage.remove(key);
        return;
      }
      if (!item || !Array.isArray(item) || item.length === 0) {
        return;
      }
      const time_stamp = item[0].time_stamp;
      const currentTime = new Date().getTime();
      if (currentTime - time_stamp >= 0) {
        window.__piniaLcStorage.remove(key);
      }
    });
  }
});
</script>
